// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".music[data-v-1003de40]{display:flex;align-items:center;height:1.31rem;border-bottom:1px solid #e0e0e0}.music-cover[data-v-1003de40]{margin-right:.24rem}.music-icon[data-v-1003de40]{margin-left:.4rem}", ""]);
// Exports
module.exports = exports;
